
import { mapGetters} from 'vuex'
import productData from '@/data/products.json'

export default {
  name: 'Downloads',
  data() {
    return {
      products: [],
      selectedProduct: {},
      show: [10162, 10163, 10164, 10165, 117, 118, 29, 32, 116, 119, 131],
      productInfo: [
        {
          id: 10162,
          title: 'General English',
          description:
            '<p>A PDF pack of 10 lesson plans suitable for individuals and small groups of online English language learners, from elementary to advanced level. Lesson plans include timings and required resources.</p>',
          image: 'wp-content/uploads/2020/05/ge_cover2_2020.jpg',
          previewUrl: 'popups/online_ge.html',
        },
        {
          id: 10163,
          title: 'Young Learners',
          description:
            '<p>10 easy-to-follow lesson plans for beginner to intermediate level English language learners. Suitable for one-to-one and small groups of students under the age of 12.</p>',
          image: 'wp-content/uploads/2020/05/yl_cover2_2020.jpg',
          previewUrl: 'popups/online_yl.html',
        },
        {
          id: 10164,
          title: 'Business English',
          description:
            '<p>10 lesson plans ranging from greetings and market vocabulary, to describing graphs and writing professional emails. This pack is suitable for Business English learners with a beginner to post-intermediate level of English.</p>',
          image: 'wp-content/uploads/2020/05/be_cover2_2020.jpg',
          previewUrl: 'popups/online_be.html',
        },
        {
          id: 10165,
          title: 'Online Lesson Plans Bundle',
          description:
            '<p>Our General English, Young Learner and Business English online lesson plan packs all in one great, money-saving bundle.</p>',
          image: 'wp-content/uploads/2020/05/bundle_cover_2020.jpg',
          previewUrl: '',
        },
        {
          id: 117,
          title: 'TEFL Games &amp; Warmers (PDF)',
          description:
            '<p>If you are looking to inject some fun into your lesson or introduce a new topic, this pack of TEFL games and warmers is for you! The PDF pack includes a total of 51 activities so there is a variety of TEFL games and warmers to suit all ages and levels of ability.</p>',
          image: 'wp-content/themes/tefl/img/games_warmers_mock_white.jpg',
          previewUrl: '',
        },
        {
          id: 118,
          title: 'Lesson Plans Pack Volume 1 (PDF)',
          description:
            '<p>Perfect for new and inexperienced teachers going into their first TEFL job. These 10 tried-and-tested plans are suitable for elementary, pre-intermediate and intermediate level learners. Plans are designed so you can and slot in different themes and/or activities to adapt your needs.</p>',
          image: 'wp-content/uploads/2021/02/LP_vol1_cover.jpg',
          previewUrl: 'popups/lessonplansVol1.html',
        },
        {
          id: 29,
          title: 'Lesson Plans Pack Volume 2 (PDF)',
          description:
            "<p><strong>What's included in the pack?</strong><ul><li>A total of 30 TEFL lesson plans for elementary to advanced level learners</li><li>Teachers' notes</li><li>Student hand-outs</li></ul>Perfect for newly qualified teachers. You'll never be stuck for ideas! </p>",
          image: 'wp-content/uploads/2021/02/LP_vol2_cover.jpg',
          previewUrl: 'popups/lessonplansVol2.html',
        },
        {
          id: 32,
          title: 'Lesson Plans Pack Volume 3 (PDF)',
          description:
            "<p>An ideal addition to your collection of lesson plans, this volume includes an incredible 40 brand new lesson plans.</p>                    <p><strong>What's inside the pack?</strong>                    <ul>                        <li>40 lesson plans</li>                        <li>Suitable for beginner to intermediate level learners</li>                    </ul></p>",
          image: 'wp-content/uploads/2021/02/LP_vol3_cover.jpg',
          previewUrl: 'popups/lessonplansVol3.html',
        },
        {
          id: 116,
          title: 'Business English PDF Lesson Plans Pack',
          description:
            "<p>An ideal resource if you are interested in getting into teaching Business English. This 81-page pack covers a range of lessons suitable for elementary to intermediate level learners.</p>                    <p><strong>What's included in the pack?</strong>                    <ul>                        <li>A total of 16 lesson plans</li>                         <li>Teachers' notes with detailed information about learning outcomes and timings</li> <li>Student handouts, including flashcards</li>                    </ul></p>",
          image: 'wp-content/uploads/2021/02/LP_BE_cover.jpg',
          previewUrl: 'popups/lessonplans.html',
        },
        {
          id: 119,
          title: 'Young Learners PDF Lesson Plans Pack',
          description:
            "<p>A must-have pack for kindergarten and elementary school EFL teachers!</p>                    <p><strong>What's included in the pack?</strong>                    <ul>                        <li>15 lesson plans</li>                        <li>Teachers' notes with learning objectives, warmers and lead-ins for each lesson</li>                        <li>Worksheets and handouts for your students</li>                    </ul></p>",
          image: 'media/439590/mockup_young_250x232.jpg',
          previewUrl: 'popups/younglearns.html',
        },
        {
          id: 131,
          title: 'The TEFL Book (PDF) by Mark Durnford',
          description:
            '<p>A 200-page manual taking you through the best ways to manage your classroom, lesson structures, teaching grammar and phonology.</p>',
          image: 'media/451867/tefl_book_250x232.jpg',
          previewUrl: 'popups/teflbook.html',
        },
      ],
    }
  },
  async fetch() {
    this.products = await productData.filter(
      (o) => o.type === 'download' && this.show.includes(o.id)
    )
    // this.$options.filters.priceData(o)
    this.products.sort(
      (a, b) => this.show.indexOf(a.id) - this.show.indexOf(b.id)
    )
  },
  methods: {
    update(product) {
      this.selectedProduct = product
    },
  },
  fetchKey: 'downloads-buttons',
  computed: {
    ...mapGetters({
      priceLabel: 'cart/getPriceLabel',
      showModal: 'cart/showAdded',
    }),
  },
}
